/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Filter_TodayInputs */

const en_ui_filter_today = /** @type {(inputs: Ui_Filter_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`today`)
};

const de_ui_filter_today = /** @type {(inputs: Ui_Filter_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`heute`)
};

/**
* | output |
* | --- |
* | "today" |
*
* @param {Ui_Filter_TodayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_today = /** @type {((inputs?: Ui_Filter_TodayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_TodayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_today(inputs)
	return de_ui_filter_today(inputs)
});